import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AvantoUserAuthService } from './avanto-user-auth.service';
import { AvantoRoutingService } from './avanto-routing.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(public auth: AvantoUserAuthService, private avantoRouting: AvantoRoutingService) { }

  canActivate(): Promise<boolean> {
    return new Promise((resolve) => {
      this.auth.getIdToken()
        .then(() => { resolve(true) })
        .catch(() => {
          console.log("User is not logged in! Redirecting to the login page.")
          this.avantoRouting.goToCustomerLoginPage();
          resolve(false);
        })
    })
  }
}
